// Important documents addedit
$(document).ready(function () {
    // On page load
    var initial_readby = $('input[name=\'forceread\']:checked').val();
    var date_input     = $('input[name="readby"]');

    if (initial_readby == 0) {
        $(date_input).parent().fadeOut();
    } else {
        if ($(date_input).val() === '') {
            $(date_input).val(dayjs().format(DATE_TIME_PICKER_FORMAT));
        }
        $(date_input).parent().fadeIn();
    }

    // If force read is set to 1, enable readby datetimepicker
    $('input[name="forceread"]').change(function () {
        if ($(this).val() == 0) {
            $(date_input).parent().fadeOut();
        } else {
            if ($(date_input).val() === '') {
                $(date_input).val(dayjs().format(DATE_TIME_PICKER_FORMAT));
            }
            $(date_input).parent().fadeIn();
        }
    });
});
